import { colors } from "../../theme";
import { BRAND_COLORS, brandRgba } from "../../utils/brandAssets";

export const compareChipSx = (selected = false) => ({
  flexShrink: 0,
  borderColor: colors.border,
  ...(selected && { fontWeight: 600 }),
  "&:hover": {
    borderColor: BRAND_COLORS.cyan,
    backgroundColor: brandRgba(BRAND_COLORS.cyan, 0.08),
  },
});
